export const isItemAllowed = (itemId, items, 
/** @deprecated Remove in the next major release */
disabledChains) => {
    var _a, _b;
    if ((_a = items === null || items === void 0 ? void 0 : items.allow) === null || _a === void 0 ? void 0 : _a.length) {
        return items.allow.includes(itemId);
    }
    return !((disabledChains === null || disabledChains === void 0 ? void 0 : disabledChains.includes(itemId)) || ((_b = items === null || items === void 0 ? void 0 : items.deny) === null || _b === void 0 ? void 0 : _b.includes(itemId)));
};
